import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class PressingCategoryService {
  url = ConfigService.toApiUrl("v1/pressing-categories/");

  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<any[]>(`${this.url}`);
  }

  get(id: any) {
    return this.http.get<any>(`${this.url}${id}`, ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }

  store(ressource: any) {
    return this.http.post<any>(`${this.url}`, ressource, ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }

  update(id: any, ressource: any) {
    return this.http.put<any>(`${this.url}${id}`, ressource, ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }

  delete(id: any) {
    return this.http.delete<any>(`${this.url}${id}`, ConfigService.httpHeader(localStorage.getItem(GlobalName.tokenName), true));
  }
}
